import React, { Component } from 'react';
import StartPage from '../PAGES/StartPage';
import SkillPage from '../PAGES/SkillPage';
import SizePage from '../PAGES/SizePage';
import GamePage from '../PAGES/GamePage';
import HelpPage from '../PAGES/HelpPage';
import { START_PAGE, SKILL_PAGE, SIZE_PAGE, GAME_PAGE, HELP_PAGE } from '../../HOME/const';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';

class Triangula extends Component {
  componentDidMount() {
    if (!this.props.page) {
      this.props.goToPage(START_PAGE);
    }
  }

  render() {
    const page = this.props.page || START_PAGE;

    return (
      <>
        {page === START_PAGE ? <StartPage /> : null}
        {page === SKILL_PAGE ? <SkillPage /> : null}
        {page === SIZE_PAGE ? <SizePage /> : null}
        {page === GAME_PAGE ? <GamePage /> : null}
        {page === HELP_PAGE ? <HelpPage /> : null}
      </>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage }
)(Triangula);
